class DLPageDotBannerH extends HTMLElement {
  constructor() {
    super();
    this.dots = [];
    this.activeDot = null;
    this.isMobile = window.innerWidth <= 990;
    this.buttonClickHandlers = new Map();
  }

  connectedCallback() {
    this.init();
    this.handleResize();
  }

  handleResize() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 990;
      
      if (!wasMobile && this.isMobile) {
        this.switchToMobile();
      }
      
      if (wasMobile && !this.isMobile) {
        this.switchToPC();
      }
      
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.recalculateExpandedItemsHeight();
      }, 150);
    });
  }

  switchToMobile() {
    if (this.activeDot) {
      this.closeDot(this.activeDot);
      this.activeDot = null;
      this.updateHasActiveState();
    }
    
    this.unbindButtonEvents();
    
    this.dots.forEach(dot => {
      const contentItems = dot.querySelectorAll('.dl-page-dotbanner-h-dot-pop-content-item');
      contentItems.forEach((item, index) => {
        if (index === 0) {
          this.expandItem(item);
        } else {
          this.collapseItem(item);
        }
      });
    });
  }

  switchToPC() {
    this.bindButtonEvents();
    
    const defaultActiveDot = this.dots.find(dot => dot.dataset.dlIsActive === 'true');
    if (defaultActiveDot) {
      this.activeDot = defaultActiveDot;
      this.updateHasActiveState();
      
      this.dots.forEach(dot => {
        const contentItems = dot.querySelectorAll('.dl-page-dotbanner-h-dot-pop-content-item');
        contentItems.forEach((item, index) => {
          if (dot === this.activeDot && index === 0) {
            this.expandItem(item);
          } else {
            this.collapseItem(item);
          }
        });
      });
    } else {
      this.dots.forEach(dot => {
        this.closeAllContentItems(dot);
      });
    }
  }

  bindButtonEvents() {
    this.dots.forEach(dot => {
      const button = dot.querySelector('.dl-page-dotbanner-h-dot-button');
      if (button && !this.buttonClickHandlers.has(button)) {
        const handler = () => this.handleDotClick(dot);
        button.addEventListener('click', handler);
        this.buttonClickHandlers.set(button, handler);
      }
    });
  }

  unbindButtonEvents() {
    this.buttonClickHandlers.forEach((handler, button) => {
      button.removeEventListener('click', handler);
    });
    this.buttonClickHandlers.clear();
  }

  init() {
    this.dots = Array.from(this.querySelectorAll('.dl-page-dotbanner-h-dot'));
    
    if (!this.isMobile) {
      this.bindButtonEvents();
    }

    this.dots.forEach(dot => {
      const contentItems = dot.querySelectorAll('.dl-page-dotbanner-h-dot-pop-content-item');
      contentItems.forEach((item, index) => {
        const header = item.querySelector('.dl-page-dotbanner-h-dot-pop-content-item-header');
        if (header) {
          header.addEventListener('click', (e) => {
            e.stopPropagation();
            this.handleContentItemClick(item, dot);
          });
        }

        if (index === 0) {
          this.expandItem(item);
        }
      });
    });

    if (!this.isMobile) {
      const defaultActiveDot = this.dots.find(dot => dot.dataset.dlIsActive === 'true');
      if (defaultActiveDot) {
        this.activeDot = defaultActiveDot;
      }
    }

    this.updateHasActiveState();
  }

  handleDotClick(clickedDot) {
    if (this.activeDot === clickedDot) {
      this.closeDot(clickedDot);
      this.activeDot = null;
      this.updateHasActiveState();
      return;
    }

    if (this.activeDot) {
      this.closeDot(this.activeDot);
      this.closeAllContentItems(this.activeDot);
    }

    this.openDot(clickedDot);
    this.activeDot = clickedDot;
    this.updateHasActiveState();
  }

  openDot(dot) {
    dot.dataset.dlIsActive = 'true';
  }

  closeDot(dot) {
    dot.dataset.dlIsActive = 'false';
  }

  updateHasActiveState() {
    if (this.activeDot) {
      this.dataset.hasActive = 'true';
    } else {
      this.removeAttribute('data-has-active');
    }
  }

  handleContentItemClick(clickedItem, dot) {
    const isExpanded = clickedItem.dataset.expanded === 'true';
    
    const allItemsInDot = dot.querySelectorAll('.dl-page-dotbanner-h-dot-pop-content-item');
    
    if (isExpanded) {
      this.collapseItem(clickedItem);
      return;
    }

    allItemsInDot.forEach(item => {
      this.collapseItem(item);
    });

    this.expandItem(clickedItem);
  }

  expandItem(item) {
    const content = item.querySelector('.dl-page-dotbanner-h-dot-pop-content-item-content');
    if (!content) return;

    item.dataset.expanded = 'true';
    const actualHeight = content.scrollHeight;
    // 根据媒体查询动态计算额外的padding值
    const extraPadding = this.isMobile 
      ? window.innerWidth * 4 / 375  // 移动端: calc(4vw / 3.75)
      : window.innerWidth * 4 / 1920; // PC端: calc(4vw / 19.2)
    content.style.maxHeight = (actualHeight + extraPadding) + 'px';
  }

  collapseItem(item) {
    const content = item.querySelector('.dl-page-dotbanner-h-dot-pop-content-item-content');
    if (!content) return;

    item.dataset.expanded = 'false';
    content.style.maxHeight = '0';
  }

  closeAllContentItems(dot) {
    const allItems = dot.querySelectorAll('.dl-page-dotbanner-h-dot-pop-content-item');
    allItems.forEach(item => {
      this.collapseItem(item);
    });
  }

  recalculateExpandedItemsHeight() {
    this.dots.forEach(dot => {
      const contentItems = dot.querySelectorAll('.dl-page-dotbanner-h-dot-pop-content-item');
      contentItems.forEach(item => {
        if (item.dataset.expanded === 'true') {
          const content = item.querySelector('.dl-page-dotbanner-h-dot-pop-content-item-content');
          if (content) {
            content.style.maxHeight = 'none';
            const newHeight = content.scrollHeight;
            // 根据媒体查询动态计算额外的padding值
            const extraPadding = this.isMobile 
              ? window.innerWidth * 4 / 375  // 移动端: calc(4vw / 3.75)
              : window.innerWidth * 4 / 1920; // PC端: calc(4vw / 19.2)
            content.style.maxHeight = (newHeight + extraPadding) + 'px';
          }
        }
      });
    });
  }
}

customElements.define('dl-page-dotbanner-h', DLPageDotBannerH);

